module.exports = __webpack_public_path__ + "img/phone.14199317.svg";